import React from 'react';
import { ConfirmActionModal } from 'components/ui/modal';
import { useTranslation } from 'react-i18next';

export default function DeleteReportModal({
  report,
  isOpen,
  onClose,
  onConfirm,
}) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  function handleConfirm() {
    onConfirm(report);
  }

  return (
    (<ConfirmActionModal
      dataTestId="ConfirmActionModal-3790d88e"
      title={t('DELETE_REPORT')}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      confirmActionText={t('DELETE')}
      confirmActionColor="red">
      {report?.name ? (
        <p data-testid="p-62038731" className="my-0">
          {t('DELETE_REPORT_CONFIRMATION')} <strong data-testid="strong-3deff680">{report?.name}</strong>
        </p>
      ) : (
        <p data-testid="p-f546abbf" className="my-0">{t('DELETE_REPORT_CONFIRMATION_NONAME')}</p>
      )}
    </ConfirmActionModal>)
  );
}
